module.exports = __webpack_public_path__ + "static/media/body_front.a2decb8b.png";